import { DataContext } from "../DataContext";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext, useRef } from "react";
import { IconLogo } from "../svgs";
import { LoaderStyles } from "../styles";
import { FourDotsLoader } from "./FourDotAnimation";

function Loader({ children }) {
  const { isLoading } = useAuth0();
  const { storeDataLoading, storeDataError, pricingProducts } = useContext(DataContext);
  // The storefront boot screen is only for the first initialization. Auth0
  // temporarily sets isLoading during popup login/cancellation, and public
  // data may refetch when authentication changes. Neither should unmount an
  // active checkout (including its Stripe Elements and entered form values).
  const initialized = useRef(false);
  if (!isLoading && !storeDataLoading) initialized.current = true;

  // Customer profile retrieval is separate from storefront initialization.
  // Do not hold the entire site on the loader when customer token renewal fails.
  if (!initialized.current) {
    return (
      <LoaderStyles>
        <IconLogo className="gg-logo" />
        <FourDotsLoader />
      </LoaderStyles>
    );
  }

  // A failed initial product request must end in an actionable state, not an infinite spinner.
  if (storeDataError && pricingProducts.length === 0) {
    return (
      <div role="alert" style={{ padding: "64px 24px", textAlign: "center" }}>
        <p>We couldn't load the store right now.</p>
        <button type="button" onClick={() => window.location.reload()}>Try again</button>
      </div>
    );
  }

  return <>{children}</>;
}

export default Loader;
